/**
 * Constantes para la sección de Matching.
 * Incluye nombres de roles de Keycloak y configuración de rutas.
 */

export const ROLES = {
    VIEW_ALL: 'sge_view_all',
    CONTABLE: 'sge_contable',
    LEGALES: 'sge_legales',
};

export const ROUTES = {
    BANCARIO: '/matching-bancario',
    JUDICIAL: '/matching-judicial',
};

export const SECTIONS = {
    BANCARIO: 'Gestión Bancaria',
    JUDICIAL: 'Gestión Legal',
};
